// import { Sidebar } from "../components/Sidebar/Sidebar";
import { Sidebar } from "@vojomo-core/shared";
import { routeConfig } from "../config/routeConfig";
import { Helmet } from "react-helmet";

interface BaseLayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
  contactFooter?: boolean;
}

const BaseLayout = ({
  children,
  pageTitle = "Vojomo Admin",
  contactFooter = true
}: BaseLayoutProps): React.ReactNode => {
  return (
    <>
      <Helmet>
        <title>{`Vojomo Admin${
          pageTitle !== "Vojomo Admin" ? " | " + pageTitle : ""
        }`}</title>
      </Helmet>

      <Sidebar routeConfig={routeConfig} activeName={pageTitle} />

      <div
        style={{
          marginLeft: "250px",
          padding: "0px 15px 0px 30px",
          boxSizing: "border-box"
        }}
      >
        {children}

        {contactFooter && (
          <footer className="text-sm italic fixed bottom-0 mb-6.25">
            <br />
            <p>
              Please contact{" "}
              <a href="mailto:matthew.balick@vojomo.com">
                matthew.balick@vojomo.com
              </a>{" "}
              for any questions.
            </p>
          </footer>
        )}
      </div>
    </>
  );
};

export default BaseLayout;
